module.exports = new __parcel__URL__("../SVG/arrow-up-circle-white.eaea173c.svg").toString();